import React, { createContext, useState, useContext, } from 'react';
const GalleryMenuContext = createContext({
    activeGalleryLink: null,
    allLinks: null,
    setActiveGalleryLink: () => { },
});
export const useGalleryMenuContext = () => {
    return useContext(GalleryMenuContext);
};
export const GalleryMenuContextProvider = ({ defaultActiveLink, allLinks = null, children, }) => {
    const [activeGalleryLink, setActiveGalleryLink] = useState(defaultActiveLink || null);
    return (React.createElement(GalleryMenuContext.Provider, { value: { activeGalleryLink, allLinks, setActiveGalleryLink } }, children));
};
//# sourceMappingURL=GalleryMenuProvider.js.map